import { formatRelative } from 'date-fns';
import { enGB } from 'date-fns/locale';
export const formatRelativeTime = (date: Date): string => {
    // Use the current date as the base date for relative formatting
    const baseDate = new Date();

    // Format the date relative to the current date
    // Use the enGB locale for British English formatting giving 24h clock
    return formatRelative(date, baseDate, { locale: enGB });
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatUtc(date: Date, format: 'full' | 'short' | 'date' = 'full'): string {
    const day = date.getUTCDate();
    const month = MONTHS[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    if (format === 'full') {
        return `${day}. ${month} ${year}, ${hours}:${minutes} UTC`;
    }
    return `${year}-${month}-${String(day).padStart(2, '0')}`;
}

export const formatStartEnd = (start: string, end?: string) => {
    if (end) {
        return `${formatUtc(new Date(start), 'short')} - ${formatUtc(new Date(end), 'short')}`;
    }
    return `${formatUtc(new Date(start), 'short')} - Continuous`;
};
